import React from 'react';
import { Eye } from 'lucide-react';
import { useReadOnly } from '../hooks/useReadOnly';
import { useAuth } from '../hooks/useAuth';

/** Says once, at the top of the app, what every greyed control below means. */
export default function ReadOnlyBanner() {
  const readOnly = useReadOnly();
  const { user } = useAuth();
  if (!readOnly) return null;
  const ghost = user?.role === 'crew_viewer';
  return (
    <div className="bg-violet-600 text-white text-xs font-semibold px-4 py-1.5 flex items-center justify-center gap-2 text-center">
      <Eye className="h-3.5 w-3.5 shrink-0" />
      {ghost
        ? `Ghost crew — seeing the crew app as ${user?.shadowing || "today's crew"} does. Nothing you tap changes anything.`
        : 'View only — you can look at everything, and nothing you tap changes it'}
    </div>
  );
}
